module.exports = __webpack_public_path__ + "img/11_60.882b07ed.png";